<template>
	<div class="wrapper">
		<div class="weui-form__control-area">
			<div class="weui-cells__group weui-cells__group_form">
				<div class="weui-cells__title">发票详情</div>
				<div class="weui-cells weui-cells_form">
					<div class="weui-cell weui-cell_active weui-cell_active-type">
						<div class="weui-cell__hd"><label class="weui-label">抬头类型</label></div>
						<div class="weui-cells weui-cells_checkbox">
							<label class="weui-cell weui-cell_active weui-check__label" v-for="item of typeList"
								@click="handleCheckedOption(item.id)">
								<div class="weui-cell__hd">
									<input type="radio" class="weui-check" name="radio" :checked="item.checked" />
									<i class="weui-icon-checked"></i>
								</div>
								<div class="weui-cell__bd">
									<span>{{ item.name }}</span>
								</div>
							</label>
						</div>
					</div>
					<div class="weui-cell weui-cell_active">
						<div class="weui-cell__hd"><label class="weui-label">公司名称</label></div>
						<div class="weui-cell__bd">
							<input id="js_input" class="weui-input" placeholder="填写发票抬头" v-model.trim="buyName" @blur="blur"
								@input="handleInput" />
						</div>
					</div>
					<div class="weui-cell weui-cell_active" v-show="type === 1">
						<div class="weui-cell__hd"><label class="weui-label">公司税号</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" placeholder="填写纳税人识别码" v-model.trim="buyerTaxCode" maxlength="24"
								@blur="blur" @input="handleInput" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="weui-cell">
			<div class="weui-cell__bd">
				<p class="weui-cell__bd_p">
					<span>总金额</span>
					<span style="color: #06ae56; padding-left: 20px">{{ totalPrice }}元</span>
				</p>
			</div>
			<div class="weui-cell__ft">共{{ count }}张</div>
		</div>
		<div class="weui-form__control-area">
			<div class="weui-cells__group weui-cells__group_form">
				<div class="weui-cells__title">接收方式</div>
				<div class="weui-cells weui-cells_form">
					<div class="weui-cell weui-cell_active">
						<div class="weui-cell__hd"><label class="weui-label">电子邮件</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" v-model.trim="eMail" placeholder="用于向您发送电子发票" @blur="blur"
								@input="handleInput" />
						</div>
					</div>
					<div class="weui-cell weui-cell_active" v-if="InvoicingType!=2">
						<div class="weui-cell__hd"><label class="weui-label">手机号码</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" placeholder="同上" v-model.trim="phonenumber" @blur="blur"
								@input="handleInput" type="tel" pattern="[0-9]*" maxlength="11" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="weui-btn-area weui-btn-area-valid">
			<button class="weui-btn weui-btn_primary" :class="!isComplete ? 'weui-btn_disabled' : ''"
				:disabled="!isComplete" @click="confirm('valid')">提交</button>
		</div>

		<div v-show="isShowConfirmDialog">
			<!--BEGIN dialog1-->
			<div class="js_dialog">
				<div class="weui-mask" @click="close"></div>
				<div id="js_half_screen_dialog" class="weui-half-screen-dialog">
					<div class="weui-half-screen-dialog__hd">
						<div class="weui-half-screen-dialog__hd__side" @click="close">
							<button class="weui-icon-btn">关闭<i class="weui-icon-close-thin"></i></button>
						</div>
						<div class="weui-half-screen-dialog__hd__main">
							<strong class="weui-half-screen-dialog__title">开具电子发票</strong>
						</div>
					</div>
					<div class="weui-half-screen-dialog__bd">
						<div class="weui-cell weui-cell_active weui-cell_disabled">
							<div class="weui-cell__hd"><label class="weui-label">发票类型</label></div>
							<div class="weui-cell__bd">
								<input class="weui-input" value="电子发票" disabled />
							</div>
						</div>
						<div class="weui-cell weui-cell_active weui-cell_disabled">
							<div class="weui-cell__hd"><label class="weui-label">发票抬头</label></div>
							<div class="weui-cell__bd">
								<input class="weui-input" :value="buyName" disabled />
							</div>
						</div>
						<div class="weui-cell weui-cell_active weui-cell_disabled" v-show="type === 1">
							<div class="weui-cell__hd"><label class="weui-label">税号</label></div>
							<div class="weui-cell__bd">
								<input class="weui-input" :value="buyerTaxCode" disabled />
							</div>
						</div>
						<div class="weui-cell weui-cell_active weui-cell_disabled" v-show="eMail">
							<div class="weui-cell__hd"><label class="weui-label">电子邮件</label></div>
							<div class="weui-cell__bd">
								<input class="weui-input" :value="eMail" disabled />
							</div>
						</div>
						<div class="weui-cell weui-cell_active weui-cell_disabled" v-show="phonenumber" v-if="InvoicingType!=2">
							<div class="weui-cell__hd"><label class="weui-label">手机号码</label></div>
							<div class="weui-cell__bd">
								<input class="weui-input" :value="phonenumber" disabled />
							</div>
						</div>
					</div>
					<p style="font-size: 12px;color: #6d6d6d; padding: 10px 0">请确认邮箱/手机号无误，电子发票将在系统开具后发送至您的邮箱或手机，请注意查收</p>
					<div class="weui-btn-area-final">
						<button class="weui-btn weui-btn_primary" @click="confirm('final')">确认提交</button>
					</div>
				</div>
			</div>
			<!--END dialog1-->
		</div>
	</div>
</template>

<script>
import { confirmTicket,NuoConfirmTicket,jLConfirmTicket } from "../../../api/coupon/receiptForWrite";
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: "index",
	data() {
		return {
			count: 0,
			type: undefined,
			InvoicingType:null,
			eMail: undefined,
			buyName: undefined,
			phonenumber: undefined,
			buyerTaxCode: undefined,
			isComplete: false,
			isShowConfirmDialog: false,
			typeList: [
				{ id: 1, name: '企业单位', checked: false },
				{ id: 2, name: '个人/非企业单位', checked: false },
			],
			receiptType: undefined
		}
	},
	watch: {
		['buyerTaxCode'](val) {
			this.$nextTick(() => {
				this.buyerTaxCode = val.replace(/\s/g, '').replace(/....(?!$)/g, '$& ');
			});
		}
	},
	computed: {
		...mapGetters(['receiptOrderSnObj', 'totalPrice', 'receiptInfo', 'receiptParkinglotId'])
	},
	created() {
		console.log(this.$route.params, 'this.$route.params');
		this.InvoicingType = this.$route.params.type
		if (this.$route.params.receiptType) {
			this.receiptType = this.$route.params.receiptType
			
		}
		if (Object.keys(this.receiptInfo).length > 0) {
			this.type = this.receiptInfo.type;
			this.eMail = this.receiptInfo.mail;
			this.buyName = this.receiptInfo.buyName;
			this.phonenumber = this.receiptInfo.phonenumber;
			this.buyerTaxCode = this.receiptInfo.buyerTaxCode;
			this.isComplete = true;
		} else {
			this.type = 1;
		}
		this.count = Object.keys(this.receiptOrderSnObj).length;
		this.typeList.map(item => {
			if (item.id == this.type) {
				item.checked = true
			}
		})
	},
	methods: {
		...mapMutations({
			setReceiptInfo: "SET_RECEPITINFO",
			setReceiptOrderSnObj: "SET_RECEIPT_ORDERSN_OBJ",
		}),
		//input失去焦点使页面上移
		blur() {
			window.scrollTo(0, 0)
		},
		handleCheckedOption(val) {
			this.type = val;
		},
		handleInput() {
			if (this.type === 2) {
				if (this.buyName && (this.eMail || this.phonenumber)) {
					this.isComplete = true
				} else {
					this.isComplete = false
				}
			} else {
				if (this.buyName && this.buyerTaxCode && (this.eMail || this.phonenumber)) {
					this.isComplete = true
				} else {
					this.isComplete = false
				}
			}

		},
		/*提交**/
		confirm(where) {
			if (where === 'valid') {
				let emailReg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //邮箱正则表达式
				let phoneReg = /^[1][3,4,5,6,7,8][0-9]{9}$/; //手机号正则
				if (this.type === 2) {
					if (this.eMail && !emailReg.test(this.eMail)) {
						this.$weui.alert('请输入合法的邮箱')
					} else if (this.phonenumber && !phoneReg.test(this.phonenumber)) {
						this.$weui.alert('请输入正确的手机号')
					} else {
						this.isShowConfirmDialog = true;
					}
				} else {
					if (this.buyerTaxCode.length != 18 && this.buyerTaxCode.length != 22 && this.buyerTaxCode.length != 24) {
						this.$weui.alert('纳税人识别码必须为15，18或20位')
					} else if (this.eMail && !emailReg.test(this.eMail)) {
						this.$weui.alert('请输入合法的邮箱')
					} else if (this.phonenumber && !phoneReg.test(this.phonenumber)) {
						this.$weui.alert('请输入正确的手机号')
					} else {
						this.isShowConfirmDialog = true
					}
				}
			} else {
				let orderArr = [];
				Object.keys(this.receiptOrderSnObj).map(item => {
					orderArr.push(this.receiptOrderSnObj[item])
				});
				let form = {
					orderArr,
					totalmoney: this.totalPrice,
					parkinglotId: this.receiptParkinglotId,
					chinaUnionTicketBO: {
						type: this.type,
						buyName: this.buyName,
						mail: this.eMail,
						buyerTaxCode: this.type === 2 ? undefined : this.buyerTaxCode.replace(/\s+/g, ""),
						phonenumber: this.phonenumber,
						receiptType: this.receiptType
					},
				};
				// 保存用户的发票信息到本地
				let recepitInfo = {
					type: this.type,
					buyName: this.buyName,
					mail: this.eMail,
					buyerTaxCode: this.type === 2 ? undefined : this.buyerTaxCode.replace(/\s+/g, ""),
					phonenumber: this.phonenumber,
				};
				this.setReceiptInfo(recepitInfo);
				if (this.$route.params.type == "0") {
					confirmTicket(form).then(res => {
						if (res.code == 200) {
							// this.setReceiptOrderSnObj({});
							this.$router.replace({ name: 'receiptResult' })
						}
					})
				} else if(this.$route.params.type == "1") {
					NuoConfirmTicket(form).then(res => {
						if (res.code == 200) {
							// this.setReceiptOrderSnObj({});
							this.$router.replace({ name: 'receiptResult' })
						}
					})

				}else{
					jLConfirmTicket(form).then(res => {
						if (res.code == 200) {
							// this.setReceiptOrderSnObj({});
							this.$router.replace({ name: 'receiptResult' })
						}
					})
				}

			}
		},
		close() {
			this.isShowConfirmDialog = false
		}
	}
}
</script>

<style scoped lang="stylus">
	.wrapper{
		height 100%
		/*background-color #eee*/
	}
	.weui-form__control-area{
		margin 0 0 10px 0
	}
	.weui-cells__group_form .weui-cells__title{
		padding 10px 16px 0 16px
	}
	.weui-cells__group_form	.weui-cells_form{
		box-shadow: 0 0 5px #eee
	}
	.weui-cells__group_form .weui-cell{
		padding 16px
	}
	.weui-cells__group_form .weui-cells:before, .weui-cells__group_form .weui-cell:before{
		left 16px
		right 16px
	}
	.weui-cell_active-type{
		display flex
	}
	.weui-cells_checkbox{
		margin-top 0
		display flex
		justify-content space-between
		flex 1
	}
	.weui-cells:before{
		border-top none
	}
	.weui-check__label{
		padding 0!important
	}
	.weui-cell{
		/*background-color #ffffff*/
	}
	.weui-cell:before{
		border-top none
	}
	.weui-cells:after{
		border-bottom none
	}
	.weui-cell__bd span{
		font-size 14px
	}
	.weui-cell__hd{
		padding-right 5px
	}
	.weui-cell__hd i{
		width 18px
		height 18px
	}
	.weui-cell__bd_p span{
		font-size 100%
	}
	.weui-btn-area-valid{
		margin 10px
		position absolute
		bottom 10px
		left 0
		right 0
		.weui-btn{
			width: 100%;
		}
	}
	.weui-half-screen-dialog__bd{
		padding-bottom 10px
	}
	.weui-btn-area-final{
		margin 10px
		.weui-btn{
			width: 100%;
		}
	}
	.weui-cell_disabled{
		padding 10px 0
	}
</style>
